(function() {
    'use strict';
    /*
     * Copyright (c) 2014-2017 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('campaignPrescription', campaignPrescription);

    function campaignPrescription() {
        return {
            restrict: 'AE',
            transclude: true,
            scope: {
                /**
                 * If provided, the campaign is within the scope of this clinic; otherwise it is an IHH campaign.
                 */
                clinic: '=',

                /**
                 * If in a clinic scope, the ID of the therapist user doing the editing.
                 */
                therapistId: '=',

                /**
                 * An object with methods to query, create, read, update, and delete campaign prescriptions.
                 */
                prescriptionsCrud: '=',

                episodeModel: '=',

                prescription: '=',
                index: '=',

                /**
                 * If provided, a function(clinic, featureString) that answers whether the clinic has that feature flag enabled.
                 */
                hasClinicFeature: '=',

                /**
                 * Indicates whether the campaign prescription is read only.
                 */
                isReadOnly: '='
            },
            controller: 'CampaignPrescriptionCtrl',
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'campaign-prescriptions/campaign-prescription.tpl.html'
        };
    }
})();
